import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logos/Main/Myceleblogo.png'
import _imports_1 from '../../assets/images/icon-right-red.png'


const _withScopeId = n => (_pushScopeId("data-v-d47301cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success-stories-area bg pt-100 pb-75" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-sm-flex justify-content-between align-items-center mb-50" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title left-title mb-0 mw-648",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "100"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
    class: "object mb-4",
    src: _imports_0,
    alt: "MyCelebrity Logo",
    style: {"max-height":"50px"}
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "Our Recent Works"),
  /*#__PURE__*/_createElementVNode("h2", { title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" }, " MyCelebrity is a celebrity and influencer agency that specialized in elevating brands through impactful collaborations. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  src: _imports_1,
  alt: "icon-right-red"
}, null, -1))
const _hoisted_6 = {
  class: "row align-items-center",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "300"
}
const _hoisted_7 = { class: "success-single-item style-two transition-y" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-content d-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/success-stories",
          class: "read-more mt-3 d-inline-block",
          "data-aos": "fade-up",
          "data-aos-duration": "1200",
          "data-aos-delay": "200"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" VIEW MORE "),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instagramPosts, (post) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-lg-3 col-sm-6",
            key: post.id
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("iframe", {
                src: `https://www.instagram.com/p/${post.code}/embed`,
                width: "100%",
                height: "480",
                frameborder: "0",
                allowfullscreen: "",
                scrolling: "no",
                allowtransparency: "true",
                class: "instagram-frame"
              }, null, 8, _hoisted_8),
              _hoisted_9
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}